import { actionCopyIt } from "./actionCopy";

export const formPageCopyIt = {
    entryFor: (label) => `Inserimento per ${label}`,
    next: actionCopyIt.next,
    back: actionCopyIt.back,
    changingAnswers: "Stai modificando risposte già date",
    submit: actionCopyIt.submit,
    startNow: "Inizia ora",
    startForm: "Inizia il modulo",
    startingForm: "Avvio del modulo...",
    formSubmitted: "Modulo inviato",
    errorsOnPage: (count) =>
        count === 1 ? "Errore su 1 domanda di questa pagina" : `Errori su ${count} domande di questa pagina`,
    invalidValue: "Valore non valido",
    groupTotal: (total, target) => `Totale: ${total} su ${target}`,
    groupMustTotal: (target) => `Queste risposte devono sommare a ${target}`,
    groupPlaced: (total, target) => `${total} su ${target} assegnati`,
    groupLeft: (n) => `ne mancano ${n}`,
    groupOver: (n) => `${n} in più`,
    groupComplete: (target) => `Tutti i ${target} assegnati`,
    countIncrease: (label) => `Aggiungi uno a ${label}`,
    countDecrease: (label) => `Togli uno da ${label}`,
    countRequired: "Inserisca un numero, o 0 se nessuno",
    answerTooHigh: "Questo numero non può essere superiore alla risposta precedente",
    exclusiveConflict: "Questa risposta non può essere combinata con le altre risposte",
    tickAtLeastOne: "Selezionare almeno una risposta",
    pageOf: (page, total) => `Pagina ${page} di ${total}`,
    carriedNote: "Abbiamo riportato questo dall'ultima volta.",
    yes: "Sì",
    no: "No",
    ownOptionOther: "Altro",
    ownOptionPlaceholder: "Scrivi la tua risposta",
    ownOptionAdd: "Aggiungi",
    ownOptionSave: "Salva",
    ownOptionCancel: "Annulla",
    ownOptionEdit: (label) => `Modifica "${label}"`,
    ownOptionDelete: (label) => `Elimina «${label}»`,
    ownOptionInUse: "Hai già usato questa risposta, quindi non può essere eliminata. Puoi rinominarla.",
    ownOptionEmpty: "Scrivere la risposta",
    ownOptionTooLong: "Usare al massimo 100 caratteri",
    ownOptionLimit: "Puoi aggiungere fino a 20 risposte personali",
    ownOptionFailed: "Non è stato possibile salvarla. Riprovare.",
    questionOf: (current, total) => `Domanda ${current} di ${total}`,
    questionsRange: (min, max) => `Domande da ${min} a ${max}`,
    questionsRangeOf: (min, max, total) => `Domande da ${min} a ${max} di ${total}`,
    formatProgressLabel: ({ min, max, total, pageNumber, pageTotal }) => {
        let questionPart: string;
        if (min === max) {
            questionPart = `Domanda ${min} di ${total}`;
        } else if (max === total) {
            questionPart = `Domande da ${min} a ${max}`;
        } else {
            questionPart = `Domande da ${min} a ${max} di ${total}`;
        }

        if (min === max && min === pageNumber && pageTotal === total) {
            return questionPart;
        }

        return `Pagina ${pageNumber} di ${pageTotal} - ${questionPart}`;
    },
};
